import { ApiResponse, PaginatedApiResponse } from '../shared.types';

import {
  HoleInOneClaimDetails,
  HoleInOneClaim,
  UpdateHoleInOneClaimStatusData,
  HoleInOneClaimBasicData,
} from './holeInOneClaim.types';

import axiosServer from '@/services/axios';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/holeInOneClaim';

export const getSubmittedHoleInOneClaims = async (
  page: number,
  pageSize: number
): Promise<PaginatedApiResponse<HoleInOneClaim>> => {
  try {
    const params: Record<string, any> = { page, pageSize };

    const response = await axiosServer.get(`${endpoint}/forAdmin`, { params });
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const getHoleInOneClaimDetails = async (
  id: string
): Promise<ApiResponse<{ claimDetails: HoleInOneClaimDetails }>> => {
  try {
    const response = await axiosServer.get(`${endpoint}/forAdmin/${id}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const updateHoleInOneClaimStatus = async (
  id: string,
  data: UpdateHoleInOneClaimStatusData
): Promise<ApiResponse<{ updatedHoleInOneClaim: HoleInOneClaimBasicData }>> => {
  try {
    const response = await axiosServer.patch(`${endpoint}/${id}/status`, data);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
